// Resolves a promise once the condition function returns true

export function waitUntil(conditionFunction: () => boolean): Promise<void> {
  const poll = resolve => {
    if (conditionFunction()) resolve();
    else setTimeout(_ => poll(resolve), 100);
  };
  return new Promise(poll);
}
